import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { trace } from 'owa-trace';
import { IconButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('../styles/videoPlayerStyles.scss');

interface BingVideoPlayerProps {
    videoPlayerHtml: string;
    onClose: () => void;
}

@observer
class BingVideoPlayer extends React.Component<BingVideoPlayerProps, {}> {
    render() {
        return (
            <div className={styles.videoPlayerBackground} onClick={this.onDismissVideoPlayer}>
                <div className={styles.videoContainer} onClick={this.onPlayerClicked}>
                    <IconButton
                        className={styles.closeButtonIcon}
                        iconProps={{ iconName: ControlIcons.ChromeClose }}
                        onClick={this.onDismissVideoPlayer}
                    />
                    <div ref={this.setAndResizeVideoPlayerContent} />
                </div>
            </div>
        );
    }

    private onDismissVideoPlayer = (evt: React.MouseEvent<EventTarget>) => {
        trace.info('Dismiss Video Player');
        evt.stopPropagation();
        this.props.onClose();
    };

    private onPlayerClicked = (evt: React.MouseEvent<EventTarget>) => {
        evt.stopPropagation();
    };

    private setAndResizeVideoPlayerContent = (videoPlayer: HTMLDivElement) => {
        if (videoPlayer) {
            videoPlayer.innerHTML = this.props.videoPlayerHtml;
            let iframes = videoPlayer.querySelectorAll('iframe');
            if (iframes && iframes.length === 1) {
                iframes[0].setAttribute('width', '800px');
                iframes[0].setAttribute('height', '530px');
            }
        }
    };
}

let videoPlayerDiv = null;
export default function showVideoPlayer(videoPlayerHtml: string): void {
    if (!videoPlayerDiv) {
        // As we can have only one video player open at a time so we only create the
        // DOM element once and reuse that.
        videoPlayerDiv = document.createElement('div');
        videoPlayerDiv.id = 'BingVideoPlayer';
        document.body.appendChild(videoPlayerDiv);
    }

    ReactDOM.render(
        <BingVideoPlayer
            videoPlayerHtml={videoPlayerHtml}
            onClose={() => {
                ReactDOM.unmountComponentAtNode(videoPlayerDiv);
            }}
        />,
        videoPlayerDiv
    );
}
